import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const CookiePolicy = () => {
  const pdfUrl = "https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/k2ajpvs6_Cookie%20Policy%20-%20HR.POL.20c%20-%20Issue%201.pdf";

  return (
    <div>
      <SEO 
        title="Cookie Policy | Green Frog Utilities"
        description="Green Frog Utilities cookie policy. Learn about how we use cookies on our website."
        canonical="/cookies"
      />
      
      {/* Hero Section */}
      <section className="relative h-[300px] bg-gradient-to-r from-emerald-600 to-emerald-700 text-white">
        <div className="absolute inset-0 bg-black/20" />
        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Cookie Policy
            </h1>
            <p className="text-xl text-emerald-100">
              How we use cookies on our website
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="flex items-start gap-4 mb-8">
              <div className="p-3 bg-emerald-100 rounded-lg">
                <FileText className="h-8 w-8 text-emerald-600" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  Cookie Policy Document
                </h2>
                <p className="text-gray-600">
                  Our full cookie policy is available as a PDF document. Click below to view or download.
                </p>
              </div>
            </div>

            <div className="border rounded-lg p-6 bg-gray-50 mb-8">
              <h3 className="font-semibold text-gray-900 mb-4">Summary</h3>
              <div className="space-y-3 text-gray-600">
                <p>
                  <strong>What are cookies?</strong> Cookies are small text files that are placed on your device when you visit our website.
                </p>
                <p>
                  <strong>Why do we use cookies?</strong> We use cookies to improve your browsing experience, analyse site traffic, and understand where our visitors come from.
                </p>
                <p>
                  <strong>Types of cookies we use:</strong>
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li><strong>Necessary cookies:</strong> Required for the website to function properly</li>
                  <li><strong>Analytics cookies:</strong> Help us understand how visitors use our site</li>
                  <li><strong>Functional cookies:</strong> Remember your preferences</li>
                </ul>
                <p>
                  <strong>Managing cookies:</strong> You can control and delete cookies through your browser settings. However, disabling cookies may affect the functionality of our website.
                </p>
              </div>
            </div>

            <a 
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Button className="bg-emerald-600 hover:bg-emerald-700 text-white">
                <FileText className="h-5 w-5 mr-2" />
                View Full Cookie Policy (PDF)
                <ExternalLink className="h-4 w-4 ml-2" />
              </Button>
            </a>

            <div className="mt-8 pt-8 border-t">
              <h3 className="font-semibold text-gray-900 mb-3">Your Cookie Preferences</h3>
              <p className="text-gray-600 mb-4">
                You can change your cookie preferences at any time by clearing your browser's cookies and revisiting our website.
              </p>
              <Button 
                variant="outline"
                onClick={() => {
                  localStorage.removeItem('cookieConsent');
                  localStorage.removeItem('cookieConsentDate');
                  window.location.reload();
                }}
              >
                Reset Cookie Preferences
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
